import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import { Youtube } from "@cinch-labs/design-system";
import styles from "./ev-charging.module.css";
import sharedStyles from "../../landing-feature-electric-cars.module.css";
import { getStoryblokImageServiceUrl } from "@cinch-nx/data-storyblok";
const VideoLinksSection = ({ firstText , video , secondText , links  })=>{
    const { videoId , title: videoTitle , buttonLabel , thumbnail  } = video;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("h4", {
                className: styles.largeText,
                children: firstText
            }),
            /*#__PURE__*/ _jsx(Youtube, {
                className: styles.video,
                videoId: videoId,
                title: videoTitle,
                buttonLabel: buttonLabel,
                customThumbnail: getStoryblokImageServiceUrl(thumbnail.filename, {
                    filters: [
                        {
                            quality: 80
                        }
                    ]
                }),
                videoUrlOptions: {
                    autoplay: 1
                },
                showNewPlayIcon: true
            }),
            /*#__PURE__*/ _jsx("h4", {
                className: styles.largeText,
                children: secondText
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: styles.linkList,
                children: links.map((link, index)=>/*#__PURE__*/ _jsx("a", {
                        href: link.url.url,
                        className: styles.linkText,
                        children: link.text
                    }, `evLink-${index}`))
            })
        ]
    });
};
export const EvCharging = ({ evCharging  })=>{
    const { title , firstText , video , secondText , links , subtitle , text  } = evCharging;
    const textContent = renderWithResolver(text);
    return /*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: sharedStyles.heading,
                children: title
            }),
            /*#__PURE__*/ _jsx(VideoLinksSection, {
                firstText: firstText,
                video: video[0],
                secondText: secondText,
                links: links
            }),
            /*#__PURE__*/ _jsx("h3", {
                className: styles.subheading,
                children: subtitle
            }),
            /*#__PURE__*/ _jsx("div", {
                className: sharedStyles.textContent,
                children: textContent
            })
        ]
    });
};
